import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setScoutActiveTab } from "../../../actions/scout-kanban";
import { usePermission } from '../../../helpers/common';

const BoardTabToggle = () => {
  const activeTab = useSelector(state => state.scoutKanban.activeTab);
  const dispatch = useDispatch();
  const allow = usePermission();
  const scoutObservation = allow("field-grouping", "view") && allow("scout-observation", "view");

  const setActiveTab = (type) => {
    dispatch(setScoutActiveTab(type));
  }

  return (
    <div>
      <div className='text-center py-3 pl-3 pr-0'>
        {scoutObservation ? <div div role="group" className="btn-group-toggle-custom btn-group-toggle btn-group btn-group-sm btn-group-toggle">
          <button type="button"
            onClick={() => setActiveTab("scout")}
            className={`${activeTab === "scout" ? "btn-primary" : "btn-default"} btn btn-sm px-4`}
          >Field Group</button>
          <button type="button"
            onClick={() => setActiveTab("observation")}
            className={`${activeTab === "observation" ? "btn-primary " :
              "btn-default"} btn btn-sm px-4`}>Observation</button>
        </div> : null}
      </div>
    </div >
  );
}
export default BoardTabToggle;
